import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function mergeClasses(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const cn = mergeClasses

export const noopFn = (): void => {
    /* Intentional no-op for placeholder callbacks */
}
